<template>
  <li v-if="to" class="breadcrumbs__item breadcrumbs__item--link ellipsis"
      :class="{'breadcrumbs__item--active': active}">
    <a :href="to" class="breadcrumbs__link">
      {{ label }}
      <span class="sr-only" v-if="active">huidige pagina</span>
    </a>
  </li>
  <li v-else class="breadcrumbs__item ellipsis" aria-current="page">
    {{ label }}
  </li>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
